module.exports = __webpack_public_path__ + "media/images/lp_01-fd0a85a2251bed583ed683817029a087.webp";